import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../Styles/Home.css";
import Navbar from "../Components/Core/Navbar.jsx";
import Footer from "../Components/Core/Footer.jsx";
import { useEffect } from "react";
import api from "../api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faFilter,
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";
import { FaHeart } from "react-icons/fa";
import Sideber from "../Components/Sidebar.jsx";
import Slider from "react-slick";
import Spin from "../Components/FullscreenSpinner.jsx";
import Skeleton from "react-loading-skeleton";

const subcategories = {
  electronics: ["Camera", "Headphone"],
  mobile: ["iPhone", "Android Phone"],
  lifestyle: ["Watch", "Shoes"],
  laptop: ["Gaming Laptop", "Ultrabook"],
};

const MobileSkeleton = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "40px",
      }}
    >
      <div>
        {" "}
        <Skeleton height={180} width={350} />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "10px",
          gap: "20px",
        }}
      >
        <Skeleton height={100} width={100} />
        <Skeleton height={100} width={100} />
        <Skeleton height={100} width={100} />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "10px",
          gap: "20px",
        }}
      >
        <Skeleton height={300} width={180} />
        <Skeleton height={300} width={180} />
      </div>
    </div>
  );
};

const DesktopSkeleton = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "50px",
      }}
    >
      <div style={{ paddingRight: "100px", paddingBottom: "30px" }}>
        {" "}
        <Skeleton height={280} width={1050} />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          gap: "70px",
        }}
      >
        <Skeleton height={100} width={100} />
        <Skeleton height={100} width={100} />
        <Skeleton height={100} width={100} />
        <Skeleton height={100} width={100} />
        <Skeleton height={100} width={100} />
        <Skeleton height={100} width={100} />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "10px",
          gap: "30px",
        }}
      >
        <Skeleton height={350} width={220} />
        <Skeleton height={350} width={220} />
        <Skeleton height={350} width={220} />
        <Skeleton height={350} width={220} />
      </div>
    </div>
  );
};

const Category = () => {
  const { categoryName } = useParams();
  const [products, setProducts] = useState([]);
  const category = categoryName;
  const [network, setNetwork] = useState(true);
  const categorySubcategories = subcategories[category] || [];
  const [selectedSubcategory, setSelectedSubcategory] = useState([]);
  const [productList, setProductList] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 891);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [banner, setBanner] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Run once on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");

  const [liked, setLiked] = useState(false);

  const [subCategory, setSubCategory] = useState([]);

  const handleFilterChange = async (filters) => {
    try {
      // Add subcategory_slug and access_token to filters
      const payload = {
        ...filters,
        //slug: [selectedSubcategory?.slug],
        access_token: JSON.parse(accessToken),
      };

      console.log("Filter payload: ", payload);
      setNetwork(true);
      const res = await api.post(`/user_api/product/filter-products`, payload);

      if (res.data.status === "success") {
        console.log("Filtered products:", res.data.product_list);
        setProductList(res.data.product_list);

        setIsSidebarOpen(false); // Close sidebar after filtering
      } else {
        console.log("No products found");
        setProductList([]);
      }
      setNetwork(false);
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  };

  console.log("Filtered Products", productList);

  useEffect(() => {
    const fetchSubcategories = async () => {
      try {
        setNetwork(true);
        const response = await api.get(
          `user_api/category/get-subcategory-list`,
          {
            params: {
              slug: categoryName,
            },
          }
        );

        if (response.data.status === "success") {
          const list = response.data.subcategory_list;
          setSubCategory(list);
          setNetwork(false);

          console.log("Subcategories:", response.data.category_banner_path);
          setBanner(response.data.category_banner_path);

          // ✅ Auto select first subcategory
          if (list.length > 0) {
            setSelectedSubcategory(list[0]);
          }
        }
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };

    fetchSubcategories();
  }, [categoryName]);

  useEffect(() => {
    getProductList();
  }, [selectedSubcategory]);
  const getProductList = async () => {
    if (!selectedSubcategory?.slug) return;

    try {
      setNetwork(true);
      const response = await api.get(
        `user_api/product/get-product-list-by-subcategory`,
        {
          params: {
            slug: selectedSubcategory.slug,
            access_token: JSON.parse(accessToken),
          },
        }
      );
      setNetwork(false);
      console.log("Products:", response.data.product_list);
      setProductList(response.data.product_list);
    } catch (error) {
      console.log("Error fetching products:", error);
    }
  };

  const addWishlist = async (id) => {
    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      const response = await api.post(`user_api/add-wishlist`, {
        access_token: JSON.parse(accessToken),
        product_id: id,
      });

      getProductList();
    } catch (error) {
      console.log("Error saving wishlist:", error);
    }
  };

  const handlePress = async (url, clicked) => {
    console.log("uyghtgh", clicked);

    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      if (!clicked) {
        navigate("/cart");
      } else {
        setNetwork(true);
        const response = await api.post(`/user_api/cart/add-to-cart-web-home`, {
          access_token: JSON.parse(accessToken),
          product_url: url,
          qty: 1,
        });
        console.log("jyghjgjgjh", response.data);
        if (response.data.status === "success") {
          getProductList();
          setNetwork(false);
        } else {
          console.log("something fisshy");
        }
      }
    } catch (error) {
      console.log("Error adding cart:", error);
    } finally {
    }
  };
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.29)",
          height: "auto",
          padding: "3px",
          width: "26px",
          borderRadius: "10px 50px 50px 10px",
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.29)",
          height: "auto",
          padding: "3px",
          width: "26px",
          borderRadius: "50px 10px 10px 50px",
        }}
        onClick={onClick}
      />
    );
  }
  const settings3 = {
    infinite: false,
    speed: 5000,
    slidesToShow: 9,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: 7,
        },
      },

      {
        breakpoint: 800,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 670,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  {
    /* return (
  <div id="wb-container" className="wb-effect10">
    <Navbar />
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        position: "relative",
        justifyContent: "center",
        height: "calc(100vh - 80px)", // Adjust 80px to your navbar height
        overflow: "hidden"
      }}
    >
      {
        /// only for mobile view
        isSidebarOpen && (
          <Sideber
            isOpen={isSidebarOpen}
            setIsOpen={setIsSidebarOpen}
            onFilterChange={handleFilterChange}
            mood={isMobile ? "mobile" : "desktop"}
          />
        )
      }

      {isMobile ? ( // for mobile view this div will be shown
        network ? (
          <MobileSkeleton />
        ) : (
          <div className="category-page" style={{ 
            width: "100%",
            height: "100%",
            overflowY: "auto"
          }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "5px",
              }}
            >
              <h2
                className="category-title section-title1"
                style={{ fontSize: "50px" }}
              >
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </h2>

              {(isMobile || !sidebarOpen) && (
                <button
                  className="sidebar-toggle"
                  onClick={() => setIsSidebarOpen(true)}
                  style={{
                    display: "block",
                    background: "transparent",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="Sidebar__title"
                    id="filter_button"
                    style={{
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      padding: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faFilter} />
                    <span>Filter</span>
                  </div>
                </button>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <img
                src={banner}
                style={{
                  width: "98%",
                  height: "220px",
                  borderRadius: "10px",
                }}
              />
            </div>

            <div
              className="subcategory-tabs"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Slider {...settings3}>
                {subCategory.map((subcat) => (
                  <div
                    className="subcategory-tab1"
                    key={subcat.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      width: "100%",
                      margin: "20px",
                    }}
                  >
                    <div
                      className={`subcategory-tab ${
                        selectedSubcategory?.id === subcat.id ? "active" : ""
                      }`}
                      onClick={() => setSelectedSubcategory(subcat)}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={subcat.subcategory_image_path}
                        alt={subcat.sub_category_name}
                        style={{
                          borderRadius: "5px",
                          width: "35px",
                          minWidth: "35px",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      {subcat.sub_category_name}
                    </span>
                  </div>
                ))}
              </Slider>
            </div>

            {selectedSubcategory && (
              <div className="product-grid-container" style={{ overflowY: "auto" }}>
                {productList?.length > 0 ? (
                  <div
                    className="product-grid"
                    style={{
                      display: "flex",
                      gap: "2rem",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {productList.map((prod, i) => (
                      <div
                        key={i}
                        className="product-card"
                        style={{
                          maxWidth: "210px",
                          minWidth: "160px",
                          boxSizing: "border-box",
                          flex: "0 0 20%",
                          position: "relative",
                        }}
                        onClick={() =>
                          navigate(
                            `/Product_details_final/${prod.product_url}`
                          )
                        }
                      >
                        <div
                          className="product-image-container"
                          style={{
                            paddingTop: "0px",
                            backgroundColor: "white",
                            width: "100%",
                            height: "100%",
                            zIndex: 0,
                          }}
                        >
                          <img
                            src={prod.product_image_path}
                            alt={prod.product_name}
                            className="product-image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                        <div
                          className="product-info"
                          style={{ padding: "0px" }}
                        >
                          <h3
                            style={{
                              margin: "5px 0",
                              fontSize: "16px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              width: "99%",
                            }}
                          >
                            {prod.product_name}
                          </h3>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              paddingBottom: "10px",
                            }}
                          >
                            <span className="selling-price">
                              AED{prod.selling_price}
                            </span>
                            <span className="original-price">
                              AED{prod.initial_cost}
                            </span>
                          </div>
                          <button
                            className="add-to-cart-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePress(prod.product_url, prod.add_to_cart);
                            }}
                          >
                            <i className="fas fa-shopping-cart"></i>
                            <span>
                              {prod.add_to_cart
                                ? "ADD TO CART"
                                : "GO TO CART"}
                            </span>
                          </button>
                        </div>
                        {prod.discout === 0 ? (
                          " "
                        ) : (
                          <div className="discount-badge pulse-animation">
                            {prod.discout}% OFF
                          </div>
                        )}
                        <div
                          style={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            cursor: "pointer",
                            zIndex: 999,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            addWishlist(prod.id);
                          }}
                        >
                          <FaHeart
                            style={{
                              color:
                                prod.wish_button === "checked"
                                  ? "red"
                                  : "gray",
                              fontSize: "20px",
                              transition: "color 0.3s",
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="no-products-found"
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      fontSize: "18px",
                      color: "#666",
                      width: "100%",
                    }}
                  >
                    No products found in this category
                  </div>
                )}
              </div>
            )}
          </div>
        )
      ) : (
        // Desktop view with dual scroll columns
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
          }}
        >

          <div style={{ 
            position: "sticky",
            top: 0,
            left: 0,
            height: "100%",
            width: "20%",
            overflowY: "auto",
            borderRight: "1px solid #eee"
          }}>
            <Sideber
              isOpen={true}
              setIsOpen={setIsSidebarOpen}
              onFilterChange={handleFilterChange}
              mood="desktop"
            />
          </div>

          {network ? (
            <DesktopSkeleton />
          ) : (
            <div
              className="category-page"
              style={{ 
                width: "80%",
                height: "100%",
                overflowY: "auto",
                padding: "0 15px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "5px",
                }}
              >
                <h2 className="category-title section-title1">
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </h2>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "10px",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                <img
                  src={banner}
                  style={{
                    width: "98%",
                    height: "220px",
                    borderRadius: "10px",
                  }}
                />
              </div>

              <div
                className="subcategory-tabs"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Slider {...settings3}>
                  {subCategory.map((subcat) => (
                    <div
                      key={subcat.id}
                      className="subcategory-tab1"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "10px",
                      }}
                    >
                      <div
                        className={`subcategory-tab ${
                          selectedSubcategory?.id === subcat.id
                            ? "active"
                            : ""
                        }`}
                        onClick={() => setSelectedSubcategory(subcat)}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={subcat.subcategory_image_path}
                          alt={subcat.sub_category_name}
                          style={{
                            objectFit: "contain",
                            borderRadius: "5px",
                            width: "45px",
                            minWidth: "45px",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        {subcat.sub_category_name}
                      </span>
                    </div>
                  ))}
                </Slider>
              </div>

              {selectedSubcategory && (
                <div className="product-grid-container">
                  {productList?.length > 0 ? (
                    <div
                      className="product-grid"
                      style={{
                        display: "flex",
                        gap: "2rem",
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}
                    >
                      {productList.map((prod, i) => (
                        <div
                          key={i}
                          className="product-card"
                          style={{
                            height: "370px",
                            maxWidth: "210px",
                            minWidth: "160px",
                            boxSizing: "border-box",
                            flex: "0 0 20%",
                            position: "relative",
                          }}
                          onClick={() =>
                            navigate(
                              `/Product_details_final/${prod.product_url}`
                            )
                          }
                        >
                          <div
                            className="product-image-container"
                            style={{
                              paddingTop: "0px",
                              backgroundColor: "white",
                              width: "100%",
                              height: "100%",
                              zIndex: 0,
                            }}
                          >
                            <img
                              src={prod.product_image_path}
                              alt={prod.product_name}
                              className="product-image"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div
                            className="product-info"
                            style={{ padding: "0px" }}
                          >
                            <h3
                              style={{
                              margin: "5px 0",
                              fontSize: "16px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              width: "99%",
                              }}
                            >
                              {prod.product_name}
                            </h3>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                paddingBottom: "10px",
                              }}
                            >
                              <span className="selling-price">
                                AED{prod.selling_price}
                              </span>
                              <span className="original-price">
                                AED{prod.initial_cost}
                              </span>
                            </div>

                            <button
                              className="add-to-cart-btn1"
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePress(
                                  prod.product_url,
                                  prod.add_to_cart
                                );
                              }}
                            >
                              <i className="fas fa-shopping-cart"></i>
                              <span>
                                {prod.add_to_cart
                                  ? "ADD TO CART"
                                  : "GO TO CART"}
                              </span>
                            </button>
                          </div>
                          {prod.discout === 0 ? (
                            " "
                          ) : (
                            <div className="discount-badge pulse-animation">
                              {prod.discout}% OFF
                            </div>
                          )}
                          <div
                            style={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              cursor: "pointer",
                              zIndex: 999,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              addWishlist(prod.id);
                            }}
                          >
                            <FaHeart
                              style={{
                                color:
                                  prod.wish_button === "checked"
                                    ? "red"
                                    : "gray",
                                fontSize: "20px",
                                transition: "color 0.3s",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div
                      className="no-products-found"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        fontSize: "18px",
                        color: "#666",
                        width: "100%",
                      }}
                    >
                      No products found in this category
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
    <Footer />
  </div>
); */
  }

  return (
    <div id="wb-container" className="wb-effect10">
      {/*network && <Spin />*/}
      <Navbar />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          position: "relative",
          justifyContent: "center",
        }}
      >
        {
          /// only for mobile view
          isSidebarOpen && (
            <Sideber
              isOpen={isSidebarOpen}
              setIsOpen={setIsSidebarOpen}
              onFilterChange={handleFilterChange}
              mood={isMobile ? "mobile" : "desktop"}
            />
          )
        }

        {isMobile ? ( // for mobile view  this div will be shown
          network ? (
            <MobileSkeleton />
          ) : (
            <div className="category-page">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "5px",
                }}
              >
                <h2
                  className="category-title section-title1"
                  style={{ fontSize: "50px" }}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </h2>
                {/* sideber */}
                {/* Toggle button for mobile */}
                {(isMobile || !sidebarOpen) && (
                  <button
                    className="sidebar-toggle"
                    onClick={() => setIsSidebarOpen(true)}
                    style={{
                      display: "block",
                      // zIndex: 9999,
                      background: "transparent",
                      border: "none",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      className="Sidebar__title"
                      id="filter_button"
                      style={{
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        padding: "9px",
                      }}
                    >
                      <FontAwesomeIcon icon={faFilter} />
                      <span>Filter</span>
                    </div>
                  </button>
                )}
              </div>
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "10px",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                <img
                  src={banner}
                  style={{
                    width: "98%",
                    height: "220px",
                    borderRadius: "10px",
                  }}
                />
              </div> */}

              <div
                className="subcategory-tabs"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Slider {...settings3}>
                  {subCategory.map((subcat) => (
                    <div
                      className="subcategory-tab1"
                      key={subcat.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        width: "100%",
                        margin: "20px",
                      }}
                    >
                      <div
                        className={`subcategory-tab ${
                          selectedSubcategory?.id === subcat.id ? "active" : ""
                        }`}
                        onClick={() => setSelectedSubcategory(subcat)}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={subcat.subcategory_image_path}
                          alt={subcat.sub_category_name}
                          style={{
                            borderRadius: "5px",
                            width: "35px",
                            minWidth: "35px",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        {subcat.sub_category_name}
                      </span>
                    </div>
                  ))}
                </Slider>
              </div>

              {/* {selectedSubcategory && (
                <div className="product-grid-container">
                  {productList?.length > 0 ? (
                    <div
                      className="product-grid"
                      style={{
                        display: "flex",
                        gap: "2rem",
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}
                    >
                      {productList.map((prod, i) => (
                        <div
                          key={i}
                          className="product-card"
                          style={{
                            maxWidth: "210px",
                            minWidth: "160px",
                            boxSizing: "border-box",
                            flex: "0 0 20%",
                            position: "relative",
                          }}
                          onClick={() =>
                            navigate(
                              `/Product_details_final/${prod.product_url}`
                            )
                          }
                        >
                          <div
                            className="product-image-container"
                            style={{
                              paddingTop: "0px",
                              backgroundColor: "white",
                              width: "100%",
                              height: "100%",
                              zIndex: 0,
                            }}
                          >
                            <img
                              src={prod.product_image_path}
                              alt={prod.product_name}
                              className="product-image"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div
                            className="product-info"
                            style={{ padding: "0px" }}
                          >
                            <h3
                              style={{
                                margin: "5px 0",
                                fontSize: "16px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                width: "99%",
                              }}
                            >
                              {prod.product_name}
                            </h3>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                paddingBottom: "10px",
                              }}
                            >
                              <span className="selling-price">
                                AED{prod.selling_price}
                              </span>
                              <span className="original-price">
                                AED{prod.initial_cost}
                              </span>
                            </div>
                            <button
                              className="add-to-cart-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePress(prod.product_url, prod.add_to_cart);
                              }}
                            >
                              <i className="fas fa-shopping-cart"></i>
                              <span>
                                {prod.add_to_cart
                                  ? "ADD TO CART"
                                  : "GO TO CART"}
                              </span>
                            </button>
                          </div>
                          {prod.discout === 0 ? (
                            " "
                          ) : (
                            <div className="discount-badge pulse-animation">
                              {prod.discout}% OFF
                            </div>
                          )}
                          <div
                            style={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              cursor: "pointer",
                              zIndex: 999,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              addWishlist(prod.id);
                            }}
                          >
                            <FaHeart
                              style={{
                                color:
                                  prod.wish_button === "checked"
                                    ? "red"
                                    : "gray",
                                fontSize: "20px",
                                transition: "color 0.3s",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div
                      className="no-products-found"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        fontSize: "18px",
                        color: "#666",
                        width: "100%",
                      }}
                    >
                      No products found in this category
                    </div>
                  )}
                </div>
              )} */}
              {selectedSubcategory && (
                <div className="product-grid-container5">
                  {productList?.length > 0 ? (
                    <div className="product-grid5">
                      {productList.map((prod, i) => (
                        <div
                          key={i}
                          className="product-card5"
                          onClick={() =>
                            navigate(
                              `/Product_details_final/${prod.product_url}`
                            )
                          }
                        >
                          <div className="product-image-wrapper5">
                            <img
                              src={prod.product_image_path}
                              alt={prod.product_name}
                              className="product-image5"
                            />
                            {prod.discout !== 0 && (
                              <div className="discount-badge5">
                                {prod.discout}% OFF
                              </div>
                            )}
                            <div
                              className="wishlist-icon5"
                              onClick={(e) => {
                                e.stopPropagation();
                                addWishlist(prod.id);
                              }}
                            >
                              <FaHeart
                                style={{
                                  color:
                                    prod.wish_button === "checked"
                                      ? "red"
                                      : "gray",
                                }}
                              />
                            </div>
                          </div>
                          <div className="product-info5">
                            <h3 className="product-name5">
                              {prod.product_name}
                            </h3>
                            <div className="price-section5">
                              <span className="selling-price5">
                                AED {prod.selling_price}
                              </span>
                              <span className="original-price5">
                                AED {prod.initial_cost}
                              </span>
                            </div>
                            <button
                              className="add-to-cart-btn5"
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePress(prod.product_url, prod.add_to_cart);
                              }}
                            >
                              <i className="fas fa-shopping-cart"></i>
                              <span>
                                {prod.add_to_cart
                                  ? "ADD TO CART"
                                  : "GO TO CART"}
                              </span>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="no-products-found5">
                      No products found in this category
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        ) : (
          // both sidebar(filter) and category page will be shown for desktop view
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              alignItems: "start",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "20%",
                left: "0",
                height: "97vh",
                overflow: "scroll",
              }}
            >
              <Sideber
                isOpen={true}
                setIsOpen={setIsSidebarOpen}
                onFilterChange={handleFilterChange}
                mood="desktop"
              />
            </div>

            {network ? (
              <DesktopSkeleton />
            ) : (
              <div
                className="category-page"
                style={{
                  width: "79%",
                  right: "0",
                  position: "relative",

                  height: "97vh",
                  overflow: "scroll",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <h2 className="category-title section-title1">
                    {category.charAt(0).toUpperCase() + category.slice(1)}
                  </h2>

                  {/* sideber */}
                  {/* Toggle button for mobile */}
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "10px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <img
                    src={banner}
                    style={{
                      width: "98%",
                      height: "220px",
                      borderRadius: "10px",
                    }}
                  />
                </div> */}

                <div
                  className="subcategory-tabs"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Slider {...settings3}>
                    {subCategory.map((subcat) => (
                      <div
                        key={subcat.id}
                        className="subcategory-tab1"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",

                          margin: "10px",
                        }}
                      >
                        <div
                          className={`subcategory-tab ${
                            selectedSubcategory?.id === subcat.id
                              ? "active"
                              : ""
                          }`}
                          onClick={() => setSelectedSubcategory(subcat)}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={subcat.subcategory_image_path}
                            alt={subcat.sub_category_name}
                            style={{
                              objectFit: "contain",
                              borderRadius: "5px",
                              width: "45px",
                              minWidth: "45px",
                            }}
                          />
                        </div>
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          {subcat.sub_category_name}
                        </span>
                      </div>
                    ))}
                  </Slider>
                </div>
                {selectedSubcategory && (
                  <div className="product-grid-container5">
                    {productList?.length > 0 ? (
                      <div className="product-grid5">
                        {productList.map((prod, i) => (
                          <div
                            key={i}
                            className="product-card5"
                            onClick={() =>
                              navigate(
                                `/Product_details_final/${prod.product_url}`
                              )
                            }
                          >
                            <div className="product-image-wrapper5">
                              <img
                                src={prod.product_image_path}
                                alt={prod.product_name}
                                className="product-image5"
                              />
                              {prod.discout !== 0 && (
                                <div className="discount-badge5">
                                  {prod.discout}% OFF
                                </div>
                              )}
                              <div
                                className="wishlist-icon5"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  addWishlist(prod.id);
                                }}
                              >
                                <FaHeart
                                  style={{
                                    color:
                                      prod.wish_button === "checked"
                                        ? "red"
                                        : "gray",
                                  }}
                                />
                              </div>
                            </div>
                            <div className="product-info5">
                              <h3 className="product-name5">
                                {prod.product_name}
                              </h3>
                              <div className="price-section5">
                                <span className="selling-price5">
                                  AED {prod.selling_price}
                                </span>
                                <span className="original-price5">
                                  AED {prod.initial_cost}
                                </span>
                              </div>
                              <button
                                className="add-to-cart-btn5"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handlePress(
                                    prod.product_url,
                                    prod.add_to_cart
                                  );
                                }}
                              >
                                <i className="fas fa-shopping-cart"></i>
                                <span>
                                  {prod.add_to_cart
                                    ? "ADD TO CART"
                                    : "GO TO CART"}
                                </span>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="no-products-found5">
                        No products found in this category
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Category;
